// extracted by mini-css-extract-plugin
export default {"root":"tooltipCard_root__WbdUm","list_wrap":"tooltipCard_list_wrap__IlD-5"};